import React, { ReactNode } from 'react';
import { JobsProvider } from './JobsContext';

interface AdminJobsProviderProps {
    children: ReactNode;
}

/**
 * Wrapper component that provides admin-mode JobsContext
 * This allows admin routes to fetch all jobs including hidden ones for super_admin
 */
export function AdminJobsProvider({ children }: AdminJobsProviderProps) {
    return (
        <JobsProvider isAdmin={true}>
            {children}
        </JobsProvider>
    );
}
